/**
 * Wires "Start Chat" (and any chat trigger) to open the Olark live chat.
 *
 * A link whose URL ends in `#start-chat`, or any element carrying
 * `data-open-chat`, opens the chat instead of jumping to the top of the page.
 * This keeps the trigger merchant-editable: set a link's URL to `#start-chat`
 * in the theme editor and it becomes a chat opener.
 *
 * Olark's global `olark()` is defined early by its inline install snippet in
 * layout/theme.liquid and queues API calls, so this works regardless of load
 * order. Guarded so it degrades gracefully (link just does nothing) if Olark
 * is ever unavailable rather than jumping to the top.
 */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('a[href$="#start-chat"], [data-open-chat]');
  if (!trigger) return;

  event.preventDefault();

  if (typeof window.olark === 'function') {
    window.olark('api.box.expand');
  }
});
